import React, { useState, useEffect, useContext } from 'react';
import { X, Tag } from 'lucide-react';
import { AppContext } from '../App';
import axios from 'axios';

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

const PromoBanner = () => {
  const { language } = useContext(AppContext);
  const [promos, setPromos] = useState([]);
  const [dismissed, setDismissed] = useState(false);
  const [currentIdx, setCurrentIdx] = useState(0);

  useEffect(() => {
    const wasDismissed = sessionStorage.getItem('promo_banner_dismissed');
    if (wasDismissed) {
      setDismissed(true);
      return;
    }

    axios.get(`${API}/promotions/active`).then(res => {
      if (Array.isArray(res.data) && res.data.length > 0) {
        setPromos(res.data);
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (promos.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIdx(prev => (prev + 1) % promos.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [promos.length]);

  if (dismissed || promos.length === 0) return null;

  const promo = promos[currentIdx];
  const discountText = promo.discount_type === 'percentage'
    ? `${promo.discount_value}%`
    : `$${promo.discount_value.toFixed(2)}`;

  const messages = {
    en: `Use code ${promo.code} for ${discountText} off${promo.min_order_amount > 0 ? ` on orders $${promo.min_order_amount}+` : ''}!`,
    tr: `${promo.code} koduyla ${discountText} indirim${promo.min_order_amount > 0 ? ` ($${promo.min_order_amount}+ siparişlerde)` : ''}!`,
    el: `Χρησιμοποιήστε τον κωδικό ${promo.code} για ${discountText} έκπτωση${promo.min_order_amount > 0 ? ` σε παραγγελίες $${promo.min_order_amount}+` : ''}!`,
    de: `Code ${promo.code} für ${discountText} Rabatt${promo.min_order_amount > 0 ? ` bei Bestellungen ab $${promo.min_order_amount}` : ''}!`
  };

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('promo_banner_dismissed', '1');
  };

  return (
    <div className="bg-gradient-to-r from-[#1F2D50] to-[#2a3d6b] text-white py-2 relative animate-fadeIn">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-center gap-3 text-sm">
        <Tag size={16} className="text-[#C8A951] flex-shrink-0" />
        <span className="font-medium text-center">
          {messages[language] || messages.en}
        </span>
        <button
          onClick={() => {
            navigator.clipboard.writeText(promo.code);
          }}
          className="bg-[#C8A951] hover:bg-[#b89842] text-[#1F2D50] font-bold text-xs px-3 py-1 rounded transition flex-shrink-0"
        >
          {promo.code}
        </button>
        <button
          onClick={handleDismiss}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 hover:text-white transition"
          aria-label="Close"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default PromoBanner;
